<nav class="navbar navbar-expand-lg fixed-top nav-bg ">
  <div class="container">
    <a class="navbar-brand" [routerLink]="['/']">
      <img src="../../assets/images/nst-logo-dark.png" alt="Logo" width="200" height="auto"
        class="d-inline-block align-text-top">
    </a>
    <button class="navbar-toggler" type="button" data-bs-toggle="offcanvas" data-bs-target="#offcanvasNavbar"
      aria-controls="offcanvasNavbar">
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="offcanvas offcanvas-end" tabindex="-1" id="offcanvasNavbar" aria-labelledby="offcanvasNavbarLabel">
      <div class="offcanvas-header">
        <h5 class="offcanvas-title" id="offcanvasNavbarLabel"></h5>
        <button type="button" class="btn-close" data-bs-dismiss="offcanvas" aria-label="Close"></button>
      </div>
      <div class="offcanvas-body">
        <ul class="navbar-nav justify-content-end flex-grow-1 nav-link-color-light pe-3">
          <li class="nav-item text-dark">
            <a class="nav-link active" [routerLink]="['/']" data-bs-dismiss="offcanvas">Home</a>
          </li>
          <li class="nav-item text-dark">
            <a class="nav-link " (click)="scrollToId('aboutSec')" data-bs-dismiss="offcanvas">About</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" (click)="scrollToId('footer')" data-bs-dismiss="offcanvas">Contact Us</a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</nav>